import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { httpClient } from "settings/apolloClient";
import SENSORS_QUERY from "views/InstrumentsPanel/graphql/queries/sensorsQuery";
import SensorMeasurementSubscribers from "views/InstrumentsPanel/Sensors/SensorMeasurementSubscriber";

// Runs the per-sensor measurement subscriptions once for the whole session, from
// the Admin layout, so navigating between pages never tears them down and
// re-triggers the @absinthe/socket resubscribe race — the race that left sensor
// values (and silo levels, which read the same normalized Sensor entities)
// frozen after a tab switch. The panels (SensorsSection / SilosSection) only read
// the httpClient cache these keep live.
const SensorMeasurementSubscribersHost = () => {
  const { data } = useQuery(SENSORS_QUERY, {
    fetchPolicy: "cache-and-network",
    client: httpClient,
  });

  const { sensors } = data || {};
  if (!sensors || !sensors.length) return null;

  return <SensorMeasurementSubscribers sensors={sensors} />;
};

export default SensorMeasurementSubscribersHost;
